export { PLUGIN_KEY, PLUGIN_PRIORITY, MultiColumnSorting } from "./multiColumnSorting.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/multiColumnSorting/index.mjs
// module id = 1494
// module chunks = 1